import { DocumentCollection, Resource } from 'ngx-jsonapi';
import { StateAction } from './state-action';

export class State extends Resource {
    public type: string = 'states';
    public attributes: {
        state: string;
        public_text: string;
        updated_at: string;
        author_id: number;
        profile_picture_url: string;
        author_name: string;
        state_reason_id: string;
        transaction_id: string;
    } = {
        state: '',
        public_text: '',
        updated_at: '',
        author_id: 0,
        profile_picture_url: '',
        author_name: '',
        state_reason_id: '',
        transaction_id: ''
    };
    public relationships: {
        state_actions: DocumentCollection<StateAction>;
    } = {
        state_actions: new DocumentCollection<StateAction>()
    };
}
